import { http, type ApiEnvelope } from "./http";
export const listImports = () =>
  http.get<never, ApiEnvelope<any[]>>("/imports");
export const getImport = (id: string) =>
  http.get<never, ApiEnvelope<any>>(`/imports/${id}`);
export const validateImport = (
  projectId: string,
  file: File,
  fieldMapping?: Record<string, string>,
) => {
  const data = new FormData();
  data.append("projectId", projectId);
  data.append("file", file);
  if (fieldMapping) data.append("fieldMapping", JSON.stringify(fieldMapping));
  return http.post<never, ApiEnvelope<any>>("/imports/validate", data);
};
export const decideConflict = (id: string, decision: string) =>
  http.patch(`/imports/conflicts/${id}`, { decision });
export const confirmImport = (id: string, confirmation: string) =>
  http.post(`/imports/${id}/confirm`, { confirmation });
export const analyzeIssue = (id: string) =>
  http.post(`/ai/issues/${id}/analyze`, {});
export const bulkAnalyze = (projectId: string, issueIds: string[]) =>
  http.post("/ai/bulk-analyze", { projectId, issueIds });
export const listAnalyses = (params?: Record<string, unknown>) =>
  http.get<never, ApiEnvelope<any[]>>("/ai/analyses", { params });
export interface ConfirmAnalysisPayload {
  decision: "accepted" | "rejected";
  applySuggestion?: boolean;
  expectedVersion?: number;
  note?: string;
}
export const confirmAnalysis = (id: string, data: ConfirmAnalysisPayload) =>
  http.post(`/ai/analyses/${id}/confirm`, data);
export const listReports = (projectId?: string) =>
  http.get<never, ApiEnvelope<any[]>>("/reports", { params: { projectId } });
export const generateReport = (data: Record<string, unknown>) =>
  http.post("/reports", data, { timeout: 75_000 });
export const reviewReport = (id: string) => http.post(`/reports/${id}/review`);
export const listNotifications = () =>
  http.get<never, ApiEnvelope<any[]>>("/notifications");
export const refreshNotifications = () => http.post("/notifications/refresh");
export const readNotification = (id: string) =>
  http.post(`/notifications/${id}/read`);
